/**
 * Entfernt die Dateigroesse aus dem Beschreibungstext der Preislisten-Kacheln.
 *
 * Das Eltern-Theme haengt serverseitig (dcLegacyApp-Core,
 * show_filegallery.inc.php) automatisch " (X.XX MB)" bzw. " (X.XX KB)" an
 * jede Dateibeschreibung an - das laesst sich nicht per Theme/Template
 * unterdruecken, da der String schon vor dem Rendern zusammengesetzt wird.
 * Daher wird das Suffix hier client-seitig aus dem sichtbaren Text entfernt.
 *
 * Vanilla JS, kein jQuery.
 */
const FILESIZE_SUFFIX = /\s*\(\s*[\d.,]+\s*(?:bytes?|KB|MB|GB)\s*\)\s*$/i;

export function initPricelistFilesize() {
    const labels = document.querySelectorAll('.downloads__pricelist .filegalleryFile span');

    labels.forEach(label => {
        label.textContent = label.textContent.replace(FILESIZE_SUFFIX, '');
    });
}